import { NumberValueAccessor } from "@angular/forms"

export class TranRecordModel {
    Seq: number
    SupSeq: number
    PetNo: number
    ClientNo: number
    ClinicNo: number
    LinkNo: number
    LinkType: number
    LinkName: string
    LinkDesc: string
    LinkFix: string
    Unit: number
    UnitCost: number
    ReqDate: string
    ReqBy: number
    ReqName: string
    ApproveDate: string
    ApproveBy: number
    ApproveName: string
    DoneDate: string                //if status = 'T' then donedate = desired start date of treatment.
    DoneBy: number               //if status = 'T' then doneby = alt_days of treatment.
    DoneName: string            //if status = 'T' then donename = time_code of treatment.
    InvDate: string
    InvBy: number
    InvName: string
    Status: string
    PStatus: number            //Y = for parent code: show children on workscreen; for children: show in history after invoice
    Tax: number                   //should be a boolean because if 1 then multiply cost by tax rate at invoice time.
    Response1: string
    Response2: string
    Approval: string
    CheckCost: string
    Cost: number
    SubCost: number
    IType: string         //Base charge to use
    Route: string         //Route of administration
    Printed: number          //Y = print this transaction on invoice
    WTime: string
    Moved: number                //if status = 'T' then moved = remain_times of treatment.
    RecallDate: string
    IsOptional: number
    IsRerequest: string
    Supervisor: number
    Attending: number
    Location: string      //Administration location
    BaseChg: string
    Dosage: number
    Days: number           //Linkage (overriding) base charge.
    AltDays: number
    Frequency: string
    IndicationID: number
    Notes: string
    Qty: number      
    DosageUnit:string     
    
    // Seq: number
    // SupSeq: number
    // PetNo: number
    // ClientNo: number
    // ClinicNo: number
    // LinkNo: number
    // LinkType: number
    // LinkName: string
    // ReturnLinkName: boolean
    // LinkDesc: string
    // LinkFix: string
    // Unit: number
    // UnitCost: number
    // ReqDate: Date
    // ReqBy: number
    // ReqName: string
    // ApproveDate: Date
    // ApproveBy: number
    // ApproveName: string
    // DoneDate: Date
    // DoneBy: number
    // DoneName: string
    // InvDate: Date
    // InvBy: number
    // InvName: string
    // Status: string
    // PStatus: boolean
    // Tax: number
    // Response1: string
    // Response2: string
    // Approval: string
    // CheckCost: string
    // Cost: number
    // SubCost: number
    // IType: string
    // Route: string
    // Printed: boolean
    // WTime: Date
    // Moved: boolean
    // RecallDate: Date
    // IsOptional: boolean
    // IsRerequest: any
    // Supervisor: number
    // Attending: number
    // Location: string
    // BaseChg: string
    // Frequency: string
    // AltDays: number
    // IndicationID: number
    // Notes: string
    // Days: number
    // Dosage: number
    // DosageUnit: string
    // Qty: number
    
    constructor() {

    }
}